import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { returnSubmit } from "../../../../enums/queryFunction/Submit";
import { HttpStatusCode } from "axios";

export default function usePutAppointmentFiles(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const [res, setRes] = React.useState(null);
  const queryClient = useQueryClient();

  const queryKey = key;

  function getErrorMessage(e) {
    if (e?.response?.data) {
      return e.response.data;
    } else if (e?.message) {
      return e.message;
    }
    return e;
  }

  const { mutateAsync } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      queryClient.invalidateQueries([queryKey]);
      handleSnackbar("successMessage", "success");
      setRes(true);
    },
    onError: (e) => {
      const errorMessage=getErrorMessage(e);
      handleSnackbar(errorMessage, "error");
      setRes(null);
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  const submitCallback = async (obj) => {
    setLoading(true);
    try {
      const response = await mutateAsync(obj);
      if (response?.status) {
        if (response.status == HttpStatusCode.Ok) {
          return true;
        }
      }
      return false;
    } catch (error) {
      return error;
    }
  };

  return {
    submitCallback,
    res,
    loading,
  };
}
